var map = {
	"./ar.json": "./src/locales/ar.json",
	"./az.json": "./src/locales/az.json",
	"./be.json": "./src/locales/be.json",
	"./bg.json": "./src/locales/bg.json",
	"./bn.json": "./src/locales/bn.json",
	"./de.json": "./src/locales/de.json",
	"./en.json": "./src/locales/en.json",
	"./es.json": "./src/locales/es.json",
	"./fa.json": "./src/locales/fa.json",
	"./fr.json": "./src/locales/fr.json",
	"./he.json": "./src/locales/he.json",
	"./hi.json": "./src/locales/hi.json",
	"./hy.json": "./src/locales/hy.json",
	"./id.json": "./src/locales/id.json",
	"./it.json": "./src/locales/it.json",
	"./ja.json": "./src/locales/ja.json",
	"./kk.json": "./src/locales/kk.json",
	"./km.json": "./src/locales/km.json",
	"./ko.json": "./src/locales/ko.json",
	"./ky.json": "./src/locales/ky.json",
	"./la.json": "./src/locales/la.json",
	"./ms.json": "./src/locales/ms.json",
	"./my.json": "./src/locales/my.json",
	"./pl.json": "./src/locales/pl.json",
	"./pt.json": "./src/locales/pt.json",
	"./ro.json": "./src/locales/ro.json",
	"./ru.json": "./src/locales/ru.json",
	"./sr.json": "./src/locales/sr.json",
	"./th.json": "./src/locales/th.json",
	"./tr.json": "./src/locales/tr.json",
	"./uk.json": "./src/locales/uk.json",
	"./uz.json": "./src/locales/uz.json",
	"./vi.json": "./src/locales/vi.json",
	"./zh-HK.json": "./src/locales/zh-HK.json",
	"./zh.json": "./src/locales/zh.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/locales sync \\.json$";